import {Component, Input, OnInit} from '@angular/core';
import {GLOBAL} from '../../global';
import { Administrator, BookingOfficer, Interpreter, IndividualClient, OrganisationalRepresentative } from '../../model/user.entity';
import { AuthGuard } from '../../../auth/auth.guard';
import { Router } from '@angular/router';
import { BookingHeaderService } from '../../../booking-management/booking-header/booking-header.service';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.css']
})
export class MobileHeaderComponent {
    @Input() title = '';
    @Input() backLink = '/booking-management';
    @Input() showBackLink = true;
    constructor(private router: Router,  private bookingHeaderService: BookingHeaderService) { }

    getPicturePath() {
        return Boolean(GLOBAL.currentUser)
            ? GLOBAL.currentUser.photo_url : '';
    }

    getActiveUserId() {
        return GLOBAL.currentUser.id;
    }

    isCurrentUserNotIndividualClientOrOrg() {
        return Boolean(GLOBAL.currentUser instanceof Administrator || GLOBAL.currentUser instanceof BookingOfficer || GLOBAL.currentUser instanceof Interpreter);
    }

    isUserIndividualClientOrOrgRep() {
        return Boolean(GLOBAL.currentUser instanceof IndividualClient || GLOBAL.currentUser instanceof OrganisationalRepresentative);
    }

    userLogout() {
        AuthGuard.logout();
        this.router.navigate(['/authenticate/logout']);
    }

    refreshBooking() {
        this.bookingHeaderService.notifyOther({option: 'refreshBooking'});
      }
}



// WEBPACK FOOTER //
// ./src/app/shared/ui/mobile-header/mobile-header.component.ts